"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPageValidationWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PageValidationMessage_1 = require("../helpers/PageValidationMessage");
var RenderUtils_1 = require("./utils/RenderUtils");
var CustomPageValidationWidget = /** @class */ (function (_super) {
    __extends(CustomPageValidationWidget, _super);
    function CustomPageValidationWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }
    CustomPageValidationWidget.prototype.render = function () {
        var journeyState = this.props.engine.getJourneyState();
        var hidePageValidationMessage = journeyState["hidePageValidationErrorMessage"] || false;
        var bottomText = (0, RenderUtils_1.renderHtml)(this.getSetting("bottomText"), this.props.interaction) || "Please try again.";
        var topText = this.getSetting("topText");
        var validationField = this.bindFromField(this.getSetting("validationField"));
        if (!validationField && bottomText && !hidePageValidationMessage) {
            return ((0, jsx_runtime_1.jsx)(PageValidationMessage_1.PageValidationMessage, { topText: topText, bottomText: bottomText, handleCloseFunction: this.handleClose }));
        }
        else {
            return null;
        }
    };
    CustomPageValidationWidget.prototype.handleClose = function () {
        var _a;
        this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = true, _a));
    };
    return CustomPageValidationWidget;
}(plugin_journey_1.WidgetBase));
exports.CustomPageValidationWidget = CustomPageValidationWidget;
//# sourceMappingURL=CustomPageValidationWidget.js.map